/** Fallback for broken images */
export function initErrorImage(): void {
  document.addEventListener(
    'error',
    (e) => {
      const target = e.target as HTMLElement
      if (target.nodeName === 'IMG') {
        ;(target as HTMLImageElement).src = '/img/placeholder.webp'
      }
    },
    true
  )
}
